import { FC } from "react";

type Props = {
	number: string;
	text: string;
	white?: boolean;
};

const PhoneTooltip: FC<Props> = ({ number, text, white }) => {
	const textColor = white ? "text-green" : "text-white";
	const bg = white ? "bg-white" : "";
	return (
		<>
			<div
				className={`${bg} rounded-[15px] border-[2px] flex gap-[30px] max-desktop:gap-[16px] max-tablet:gap-[20px] h-[155px]  max-desktop:h-[89px] max-tablet:h-[93px] items-center px-[30px] max-desktop:px-[22px] max-tablet:px-[18px]  max-tablet:pr-[7px] max-tablet:pl-[18px] ${
					number === "36" ? "max-tablet:gap-[20px]" : "max-tablet:gap-[43px]"
				}`}>
				<p
					className={`${textColor} ${
						number === "36" ? "pl-[-8px]" : "max-desktop:pl-[16px]"
					} text-[117px] max-desktop:text-[67px] font-bold leading-[155px] max-desktop:leading-[89px]`}>
					{number}
				</p>
				<p
					className={`${textColor}  text-[28px] max-desktop:text-[15px] ${
						white ? "font-[400]" : "font-[300]"
					} ${
						number === "6" ? "pr-[20px] max-desktop:pr-0" : ""
					} font-[300] leading-[28px] max-desktop:leading-[14px]  max-tablet:tracking-[0.3px] tracking-[0.2px]  max-desktop:tracking-[0.15px] max-tablet:pr-[7px]`}>
					{text}
				</p>
			</div>
			<div className='hidden max-tablet:block h-[12px] border-[1px] w-[1px] mx-auto'></div>
		</>
	);
};

export default PhoneTooltip;
